import React from 'react';
import { canvasBackgroundColor } from '../styles/SharedStyles';
import { useThemeContext } from '../context';
import { app } from "@microsoft/teams-js";

export interface RouteWrapperProps {
  children?: any;
}

export function RouteWrapper({ children }: RouteWrapperProps): JSX.Element {
  const theme = useThemeContext();
  app.initialize(["https://teams.microsoftonline.cn"]);
  return (
    <div
      style={{ backgroundColor: canvasBackgroundColor(theme), height: '100%' }}
    >
      {children}
    </div>
  );
}
